import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faMobile, faGlobe, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Avatar from '@material-ui/core/Avatar';
import Flip from 'react-reveal/Flip';

const styles = theme => ({
  customGrid:{
    position: 'relative',
    paddingBottom: 16,
    marginTop: 20,
    [theme.breakpoints.up('md')]: {
        maxWidth: '14.23%',
        flexBasis: '14.23%'
    }
  }
})
class Platforms extends React.Component{
    constructor(props){
        super(props);
        this.state = {
         items:[
            { 
                icon: faDesktop, 
                title: 'Desktop', 
                link: 'https://www.duwun.com.mm/',
                class: 'icon-desktop',
                delay: 200
            },
            { 
                icon: faMobile, 
                title: 'Mobile', 
                link: 'https://www.duwun.com.mm/',
                class: 'icon-mobile',
                delay: 400
            },
            { 
                icon: faGlobe, 
                title: 'Web', 
                link: 'https://www.duwun.com.mm/',
                class: 'icon-web',
                delay: 600
            },
            { 
                icon: ['fab', 'facebook-f'], 
                title: 'Facebook', 
                link: 'https://www.facebook.com/duwun/',
                class: 'icon-facebook',
                delay: 800
            },
            { 
                icon: ['fab', 'instagram'], 
                title: 'Instagram', 
                link: 'https://www.instagram.com/duwun/',
                class: 'icon-instagram',
                delay: 1000
            },
            { 
                icon: ['fab', 'youtube'], 
                title: 'Youtube', 
                link: 'https://www.youtube.com/duwun',
                class: 'icon-youtube',
                delay: 1200
            },
            { 
                icon: ['fab', 'viber'], 
                title: 'Viber', 
                link: 'https://invite.viber.com/?g2=AQA9Au5gBb0XwUj3men7K9GNqPwg6OV615k%2BWT6PtmuBvI1s2rOSiyHTtE6Y0Res&lang=en',
                class: 'icon-viber',
                delay: 1400
            },
        ]
        };
      }  
    render(){
        const { classes, items } = this.props;
        return(
            <>
            <Grid container  
            direction="row"
            justify="space-evenly"
            alignItems="center"
            className="platforms advertise-layout"
            style={{marginBottom: '4em'}}
            >
            <Grid item md={12} xs={12} >
                <h2 style={{ padding: '30px 0px 0px', color: '#ed7123', fontSize: 30 }}> Our Platforms</h2>
            </Grid>
            {
                this.state.items.map((item, i) => {
                    return(
                        <React.Fragment key={i}>
                            <Grid item md={1} sm={4} xs={4} style={{marginTop: 20}}>
                                <a href={item.link} target="_blank">
                                    <Flip left delay={item.delay}>
                                        <Avatar className='title' style={{ width: 80, height: 80, margin: '0 auto' }} className={item.class}>
                                            <p>
                                                <FontAwesomeIcon icon={item.icon} style={{ width: '1.5em', height: '1.5em', marginTop: 10}} ></FontAwesomeIcon>
                                            </p>
                                        </Avatar>
                                    </Flip>
                                </a>
                                <Flip left delay={item.delay}>
                                    <h4>{item.title}</h4>
                                </Flip>
                            </Grid>
                        </React.Fragment>
                    )
                })
            }
            </Grid>
         
            <Grid container id="contact">
                <Grid item md={6} xs={12}>
                    <p>Contact us today to reach to the tour targeted audience at</p>
                </Grid>
                <Grid item md={3} xs={12}>
                    <div className='contact-item'> 
                        <FontAwesomeIcon icon={faEnvelope} ></FontAwesomeIcon>
                    </div>
                    <a href="mailto:sales@duwun.com.mm">
                        <span>Gmail: sales@duwun.com.mm</span>
                    </a>
                </Grid>
                <Grid item md={3} xs={12}>
                    <div className='contact-item'>
                        <FontAwesomeIcon icon={faPhone} ></FontAwesomeIcon>
                    </div>
                    <a href="tel:09972052818">
                        <span>Phone:09972052818</span>
                    </a>
                </Grid>
            </Grid> 
            </>
        )
    }
}
export default withStyles(styles)(Platforms);